import { flare } from "@flareapp/flare-client";

if (process.env.NODE_ENV === 'production') {
    flare.light('qjgK6slF51MPAeJkiRoDYTuqyB1kE6hU');
}

require('./bootstrap');
//
